import template from './chat.tpl.html';
import controller from './chat.controller';

export default function() {
    return {
        restrict: 'E',
        scope: {
            fullscreen: '@fullscreen',
            isNicknameRequired: '@nickname',
            isAnnouncements: '@announcements',
            signalNewComment: '&',
            signalNewAnnouncement: '&',
            pageSize: '<pageSize'
        },
        controller: controller,
        controllerAs: 'ctrl',
        bindToController: true,
        template: template
    };
}
